import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import { formatDollars, TWO_DECIMAL_DIGITS } from '../utils/formatting';
import { DOLLAR_PRICE_MIN_VALUE } from '../utils/profits';
import s from './EarningsDisplay.scss';
var EarningsDisplay = function (_a) {
    var dollarPrice = _a.dollarPrice, productType = _a.productType, requestEarningsCalculation = _a.requestEarningsCalculation, _b = _a.estimatedEarningsResponse, estimatedEarningsResponse = _b === void 0 ? {} : _b, className = _a.className;
    var t = useTranslation().t;
    var dollarEarnings = estimatedEarningsResponse.dollarEarnings, serviceFee = estimatedEarningsResponse.serviceFee;
    var feePercentage = dollarPrice && serviceFee
        ? Math.round(parseFloat(serviceFee) / parseFloat(dollarPrice) * 100)
        : undefined;
    useEffect(function () {
        if (dollarPrice && productType) {
            requestEarningsCalculation(dollarPrice, productType);
        }
    }, [dollarPrice, productType, requestEarningsCalculation]);
    if (!dollarPrice || +dollarPrice <= DOLLAR_PRICE_MIN_VALUE) {
        return null;
    }
    return (React.createElement("div", { className: cn(s['root'], className) },
        t('earningsDisplay.label'),
        ' ',
        dollarEarnings && (React.createElement("span", { className: s['earnings'] }, formatDollars(+dollarEarnings, TWO_DECIMAL_DIGITS))),
        feePercentage && (React.createElement(SophisticatedTooltip, { size: "medium", placement: "top", "aria-label": t('earningsDisplay.tooltip', { feePercentage: feePercentage }), description: t('earningsDisplay.tooltip', { feePercentage: feePercentage }), width: 218 },
            React.createElement(InfoIcon, { className: s['info-icon'], size: IconSize.SMALLER, disableDefaultColors: true })))));
};
EarningsDisplay.displayName = 'EarningsDisplay';
export default EarningsDisplay;
//# sourceMappingURL=EarningsDisplay.js.map